import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APIS } from '../enums/apis';


export interface PostCsvIntegration {
    tableKey: string;
    csv: string;
}

export interface CsvImportError {
    rowNumber: number;
    message: string;
}

export interface CsvImportResult {
    tableKey: string;
    totalRows: number;
    insertedRows: number;
    failedRows: number;
    errors: CsvImportError[];
}

@Injectable({
    providedIn: 'root'
})
export class IntegrationService {

    constructor(
        private http: HttpClient,
    ) { }

   

    getIntegrationConfigurationCSV(qps?: string): Observable<Blob> {
        const queryHeaders = new HttpHeaders().append('Content-Type', 'application/json');
        return this.http
            .get(`${environment.apiIntegrationsServer}${APIS.INTEGRATIONS_EXPORT_CONFIG}`, {
                headers: queryHeaders,
                observe: 'response',
                responseType: 'blob',
                params: qps ? JSON.parse(qps) : {}
            })
            .pipe<any>(
                map<HttpResponse<any>, any>((response) => {
                    return response.body;
                }),
            );
    }

    postIntegrationConfigurationCSV(body: PostCsvIntegration): Observable<CsvImportResult> {
        return this.http.post<CsvImportResult>(
            `${environment.apiIntegrationsServer}${APIS.INTEGRATIONS_IMPORT_CONFIG}`,
            body,
        );
    }
}